import script from "./ProductCardAddons.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCardAddons.vue?vue&type=script&setup=true&lang=ts"

import "./ProductCardAddons.vue?vue&type=style&index=0&id=b8768ab6&lang=scss"

const __exports__ = script;

export default __exports__